(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breed-filter-nav"] && !Shopify.designMode) return;
  try {
    
  const initialiseBreedAlphabet = (root) => {
    if (root.dataset.breedFilterReady === 'true') return;

    const main = root.closest('main') || document.querySelector('#MainContent');
    const header = document.querySelector('.section-header');
    const alphabet = root.querySelector('.breed-filter-nav__alphabet');
    const letterButtons = Array.from(root.querySelectorAll('[data-breed-letter]'));

    if (!main || !alphabet) return;

    const cards = Array.from(main.querySelectorAll('.section-collection-list .collection-list__item'))
      .map((item) => {
        const link = item.querySelector('.card__heading a');
        return {
          item,
          title: link ? link.textContent.trim() : ''
        };
      })
      .filter((card) => card.title);

    const availableLetters = new Set(
      cards
        .map((card) => card.title.charAt(0).toLocaleUpperCase())
        .filter(Boolean)
    );

    let stickyFrame = null;
    let activeFrame = null;
    let followHeaderUntil = 0;
    let manualScrollUntil = 0;
    let manualScrollTimer = null;

    const resetLetterState = () => {
      letterButtons.forEach((button) => button.removeAttribute('aria-current'));
    };

    const keepLetterVisible = (button) => {
      const buttonRect = button.getBoundingClientRect();
      const alphabetRect = alphabet.getBoundingClientRect();

      if (buttonRect.left >= alphabetRect.left + 4 && buttonRect.right <= alphabetRect.right - 4) {
        return;
      }

      const targetLeft =
        button.offsetLeft - (alphabet.clientWidth - button.offsetWidth) / 2;

      alphabet.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: 'smooth'
      });
    };

    const setActiveLetter = (letter, keepVisible) => {
      const button = letterButtons.find(
        (candidate) => candidate.dataset.breedLetter === letter && !candidate.disabled
      );

      if (!button || button.getAttribute('aria-current') === 'true') return;

      resetLetterState();
      button.setAttribute('aria-current', 'true');

      if (keepVisible) {
        keepLetterVisible(button);
      }
    };

    const syncStickyOffset = (now) => {
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      root.style.setProperty('--breed-nav-top', `${headerBottom}px`);

      if (now < followHeaderUntil) {
        stickyFrame = window.requestAnimationFrame(syncStickyOffset);
      } else {
        stickyFrame = null;
      }
    };

    const queueStickyOffsetSync = () => {
      followHeaderUntil = performance.now() + 250;

      if (stickyFrame === null) {
        stickyFrame = window.requestAnimationFrame(syncStickyOffset);
      }
    };

    const updateActiveLetter = () => {
      activeFrame = null;

      if (performance.now() < manualScrollUntil || cards.length === 0) return;

      const threshold = root.getBoundingClientRect().bottom + 8;
      let currentCard = cards[cards.length - 1];

      for (const card of cards) {
        if (card.item.getBoundingClientRect().bottom > threshold) {
          currentCard = card;
          break;
        }
      }

      setActiveLetter(currentCard.title.charAt(0).toLocaleUpperCase(), true);
    };

    const queueActiveLetterUpdate = () => {
      if (activeFrame === null) {
        activeFrame = window.requestAnimationFrame(updateActiveLetter);
      }
    };

    const queueViewportSync = () => {
      queueStickyOffsetSync();
      queueActiveLetterUpdate();
    };

    letterButtons.forEach((button) => {
      const letter = button.dataset.breedLetter;

      if (!availableLetters.has(letter)) {
        button.disabled = true;
        return;
      }

      button.addEventListener('click', () => {
        manualScrollUntil = performance.now() + 900;
        setActiveLetter(letter, true);

        const target = cards.find(
          (card) => card.title.charAt(0).toLocaleUpperCase() === letter
        );

        if (target) {
          target.item.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }

        if (manualScrollTimer) {
          window.clearTimeout(manualScrollTimer);
        }

        manualScrollTimer = window.setTimeout(() => {
          manualScrollUntil = 0;
          queueActiveLetterUpdate();
        }, 950);
      });
    });

    queueViewportSync();
    window.addEventListener('scroll', queueViewportSync, { passive: true });
    window.addEventListener('resize', queueViewportSync);

    if (header) {
      const headerObserver = new MutationObserver(queueViewportSync);
      headerObserver.observe(header, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });

      if ('ResizeObserver' in window) {
        const headerResizeObserver = new ResizeObserver(queueViewportSync);
        headerResizeObserver.observe(header);
      }
    }

    root.dataset.breedFilterReady = 'true';
  };

  const initialiseBreedAlphabets = () => {
    document.querySelectorAll('[data-breed-filter-nav]').forEach(initialiseBreedAlphabet);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseBreedAlphabets);
  } else {
    initialiseBreedAlphabets();
  }

  document.addEventListener('shopify:section:load', initialiseBreedAlphabets);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-downloads-test"]) return;
  try {
    
document.querySelectorAll('[data-cc-downloads]').forEach(root => {
  const registryNode = root.querySelector('[data-collection-registry]');
  // Launch pilot: retain the complete registry untouched but expose only these
  // three collections in the ordinary draft preview. Append ?cc_development=all
  // to the URL to inspect all 11 artwork-development collections.
  const allPacks = registryNode ? JSON.parse(registryNode.textContent).collections : [];
  const developmentView = new URLSearchParams(window.location.search).get('cc_development') === 'all';
  const pilotIds = new Set(['weimaraner', 'maine-coon', 'german-shepherd']);
  const packs = developmentView ? allPacks : allPacks.filter(pack => pilotIds.has(pack.id));
  const uiNode = root.querySelector('[data-collection-ui]');
  const ui = uiNode ? JSON.parse(uiNode.textContent) : {};
  const escapeHtml = value => String(value).replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  const money = value => new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(value / 100);
  const previewSrcset = url => [360, 720, 1280, 1800].map(width => `${url}${url.includes('?') ? '&' : '?'}width=${width} ${width}w`).join(', ');
  const artHtml = artwork => `<figure><button type="button" class="cc-downloads__enlarge" data-art-preview aria-label="${escapeHtml(ui.enlarge + ': ' + artwork.title)}"><img src="${escapeHtml(artwork.url)}" srcset="${escapeHtml(previewSrcset(artwork.url))}" sizes="(min-width: 700px) 25vw, 50vw" alt="${escapeHtml(artwork.alt)}" width="${artwork.width}" height="${artwork.height}" loading="lazy"></button><figcaption>${escapeHtml(artwork.title)}</figcaption></figure>`;
  packs.forEach(pack => {
    // Never imply a purchasable £7.95 bundle before file quality and price approval.
    const summary = !developmentView ? `${pack.artworks.length} ${ui.artworks} · Launch testing` : (pack.complete ? `${pack.artworks.length} ${ui.artworks} · ${money(pack.price)}` : `${pack.artworks.length} / ${pack.target} ${ui.planned}`);
    const add = !developmentView ? `<p class="cc-downloads__progress">Checkout coming after proof approval</p>` : (pack.complete ? `<button class="button" type="button" data-preview-add="${pack.id}">${escapeHtml(ui.add)}</button>` : `<p class="cc-downloads__progress">${escapeHtml(ui.progress)}</p>`);
    const tile = document.createElement('article');
    tile.className = 'cc-downloads__collection-card';
    tile.dataset.collectionTile = '';
    tile.dataset.artSubject = pack.subject;
    tile.dataset.season = pack.season;
    tile.dataset.search = `${pack.name} ${pack.breed}`.toLowerCase();
    tile.innerHTML = `<button type="button" class="cc-downloads__cover-image" data-open-collection="${pack.id}" aria-controls="cc-collection-${pack.id}" aria-expanded="false" aria-label="${escapeHtml(ui.open + ': ' + pack.name)}"><img src="${escapeHtml(pack.cover.url)}" srcset="${escapeHtml(previewSrcset(pack.cover.url))}" sizes="(min-width: 700px) 33vw, 100vw" alt="${escapeHtml(pack.cover.alt)}" width="${pack.cover.width}" height="${pack.cover.height}" loading="lazy"></button><div class="cc-downloads__cover-copy"><p class="cc-downloads__eyebrow">${escapeHtml(pack.season + ' · ' + pack.breed)}</p><h3>${escapeHtml(pack.name)}</h3><p>${escapeHtml(summary)}</p><div class="cc-downloads__pack-actions"><button class="button" type="button" data-open-collection="${pack.id}" aria-controls="cc-collection-${pack.id}" aria-expanded="false">${escapeHtml(ui.open)} →</button>${add}</div></div>`;
    root.querySelector('[data-collection-covers]').append(tile);
    const panel = document.createElement('article');
    panel.className = 'cc-downloads__collection';
    panel.id = `cc-collection-${pack.id}`;
    panel.dataset.collectionPanel = pack.id;
    panel.hidden = true;
    panel.innerHTML = `<button class="button cc-downloads__collection-back" type="button" data-back-collections>${escapeHtml(ui.back)} ↑</button><div class="cc-downloads__collection-heading"><div><h2>${escapeHtml(pack.name)}</h2><p>${escapeHtml(pack.intro)}</p></div><p class="cc-downloads__price">${escapeHtml(summary)}</p></div><p>${escapeHtml(ui.all)}</p><div class="cc-downloads__pack-grid">${pack.artworks.map(artHtml).join('')}</div><details class="cc-downloads__scene-list"><summary>${escapeHtml(ui.titles)}</summary><ol>${pack.artworks.map(art => `<li>${escapeHtml(art.title)}</li>`).join('')}</ol></details><div class="cc-downloads__pack-actions">${add}<a class="button" href="#cc-pack-formats">${escapeHtml(ui.included)}</a></div>`;
    root.querySelector('[data-collection-panels]').append(panel);
  });
  const dialog = root.querySelector('dialog');
  const returnLink = root.querySelector('.cc-downloads__return a');
  if (returnLink) returnLink.addEventListener('click', () => {
    const header = document.querySelector('.shopify-section-header-sticky');
    root.style.setProperty('--cc-header-offset', `${header ? header.getBoundingClientRect().height : 0}px`);
  });
  const viewport = dialog.querySelector('.cc-downloads__preview-viewport');
  const canvas = dialog.querySelector('[data-preview-canvas]');
  let zoom = 1;
  const setZoom = (next, reset = false) => {
    const centreX = (viewport.scrollLeft + viewport.clientWidth / 2) / Math.max(viewport.scrollWidth, 1);
    const centreY = (viewport.scrollTop + viewport.clientHeight / 2) / Math.max(viewport.scrollHeight, 1);
    zoom = Math.max(1, Math.min(4, next));
    canvas.style.width = `${zoom * 100}%`;
    canvas.style.setProperty('--preview-width', `${660 * zoom}px`);
    canvas.dataset.zoomed = String(zoom > 1);
    dialog.querySelector('[data-zoom-level]').textContent = `${Math.round(zoom * 100)}%`;
    dialog.querySelector('[data-zoom-out]').disabled = zoom === 1;
    dialog.querySelector('[data-zoom-in]').disabled = zoom === 4;
    viewport.scrollLeft = reset ? 0 : centreX * viewport.scrollWidth - viewport.clientWidth / 2;
    viewport.scrollTop = reset ? 0 : centreY * viewport.scrollHeight - viewport.clientHeight / 2;
  };
  dialog.querySelector('[data-zoom-in]').addEventListener('click', () => setZoom(zoom + 0.5));
  dialog.querySelector('[data-zoom-out]').addEventListener('click', () => setZoom(zoom - 0.5));
  dialog.querySelector('[data-zoom-reset]').addEventListener('click', () => setZoom(1, true));
  const setPreviewCaption = (figure, fallback) => {
    const target = dialog.querySelector('[data-preview-title]');
    target.replaceChildren();
    const heading = figure && figure.querySelector('figcaption h3, h3');
    const description = figure && figure.querySelector('figcaption p');
    const caption = figure && figure.querySelector('figcaption');
    const title = document.createElement('h3');
    title.textContent = heading ? heading.textContent.trim() : caption ? caption.textContent.trim() : fallback;
    target.append(title);
    if (description && description.textContent.trim()) {
      const body = document.createElement('p');
      body.textContent = description.textContent.trim();
      target.append(body);
    }
  };
  const artButtons = [...root.querySelectorAll('[data-art-preview]')];
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const previewImage = canvas.querySelector('img');
  const toggleImageZoom = event => {
    if (previewImage.hidden || canvas.dataset.artWatermark !== 'true') return;
    const rect = previewImage.getBoundingClientRect();
    const x = event && Number.isFinite(event.clientX) ? (event.clientX-rect.left)/rect.width : 0.5;
    const y = event && Number.isFinite(event.clientY) ? (event.clientY-rect.top)/rect.height : 0.5;
    const zoomIn = zoom === 1;
    setZoom(zoomIn ? 2 : 1,true);
    if (zoomIn) {
      viewport.scrollLeft = Math.max(0,Math.min(viewport.scrollWidth-viewport.clientWidth,x*viewport.scrollWidth-viewport.clientWidth/2));
      viewport.scrollTop = Math.max(0,Math.min(viewport.scrollHeight-viewport.clientHeight,y*viewport.scrollHeight-viewport.clientHeight/2));
    }
  };
  previewImage.addEventListener('click',toggleImageZoom);
  viewport.addEventListener('keydown',event => {
    if (event.target !== viewport || (event.key !== 'Enter' && event.key !== ' ')) return;
    if (previewImage.hidden || canvas.dataset.artWatermark !== 'true') return;
    event.preventDefault();
    toggleImageZoom();
  });
  viewport.addEventListener('pointermove',event => {
    if (!finePointer.matches || event.pointerType !== 'mouse' || zoom === 1 || previewImage.hidden || canvas.dataset.artWatermark !== 'true') return;
    const rect = viewport.getBoundingClientRect();
    viewport.scrollLeft = Math.max(0,Math.min(1,(event.clientX-rect.left)/rect.width))*(viewport.scrollWidth-viewport.clientWidth);
    viewport.scrollTop = Math.max(0,Math.min(1,(event.clientY-rect.top)/rect.height))*(viewport.scrollHeight-viewport.clientHeight);
  });
  const imageNav = dialog.querySelector('[data-image-nav]');
  let collectionImages = [];
  let imageIndex = 0;
  const showArtwork = (button, index) => {
    dialog.querySelector('[data-format-expanded]').replaceChildren();
    dialog.querySelector('img').hidden = false;
    canvas.dataset.artWatermark = 'true';
    const source = button.querySelector('img');
    const ratio = Number(source.getAttribute('width')) / Number(source.getAttribute('height'));
    canvas.style.setProperty('--cc-preview-ratio', String(Number.isFinite(ratio) && ratio > 0 ? ratio : 1.5));
    const image = dialog.querySelector('img');
    image.src = source.src;
    image.alt = source.alt;
    const figure = button.closest('figure, article');
    setPreviewCaption(figure, source.alt);
    imageIndex = index;
    imageNav.hidden = collectionImages.length < 2;
    dialog.querySelector('[data-image-position]').textContent = `${imageIndex + 1} / ${collectionImages.length}`;
    if (!dialog.open) dialog.showModal();
    setZoom(1, true);
  };
  artButtons.forEach(button => button.addEventListener('click', () => {
    let panel = button.closest('[data-collection-panel]');
    if (!panel && button.closest('.cc-downloads__hero')) {
      panel = [...root.querySelectorAll('[data-collection-panel]')].find(item => [...item.querySelectorAll('[data-art-preview] img')].some(image => image.src === button.querySelector('img').src));
    }
    collectionImages = panel ? [...panel.querySelectorAll('[data-art-preview]')] : [button];
    const index = Math.max(0, collectionImages.findIndex(item => item.querySelector('img').src === button.querySelector('img').src));
    showArtwork(button, index);
  }));
  const moveArtwork = direction => {
    if (collectionImages.length < 2) return;
    const next = (imageIndex + direction + collectionImages.length) % collectionImages.length;
    showArtwork(collectionImages[next], next);
  };
  dialog.querySelector('[data-prev-art]').addEventListener('click', () => moveArtwork(-1));
  dialog.querySelector('[data-next-art]').addEventListener('click', () => moveArtwork(1));
  dialog.addEventListener('keydown', event => {
    if (zoom !== 1 || collectionImages.length < 2) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      moveArtwork(event.key === 'ArrowLeft' ? -1 : 1);
    }
  });
  root.querySelectorAll('img').forEach(image => {
    if (image.closest('dialog, [data-art-preview], .cc-downloads__cover-image, .cc-downloads__frame')) return;
    const wrap = document.createElement('span');
    wrap.className = 'cc-downloads__watermarked-image';
    image.replaceWith(wrap);
    wrap.append(image);
  });
  root.querySelectorAll('[data-format-preview]').forEach(button => {
    button.addEventListener('click', () => {
      collectionImages = [];
      imageNav.hidden = true;
      canvas.dataset.artWatermark = 'false';
      dialog.querySelector('img').hidden = true;
      const scene = button.firstElementChild.cloneNode(true);
      dialog.querySelector('[data-format-expanded]').replaceChildren(scene);
      setPreviewCaption(button.closest('figure'), button.getAttribute('aria-label'));
      dialog.showModal();
      setZoom(1, true);
    });
  });
  dialog.querySelector('[data-close-preview]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  const basketDialog = root.querySelector('.cc-downloads__basket');
  const cartKey = 'cc-digital-preview-basket-v1';
  let basket = [];
  try { basket = JSON.parse(sessionStorage.getItem(cartKey) || '[]').filter(line => packs.some(pack => pack.id === line.id && pack.complete) && Number.isInteger(line.quantity) && line.quantity > 0 && line.quantity < 100); } catch { basket = []; }
  const renderBasket = () => {
    const lines = root.querySelector('[data-preview-cart-lines]');
    lines.innerHTML = basket.length ? basket.map(line => {
      const pack = packs.find(item => item.id === line.id);
      return `<article class="cc-downloads__basket-line"><div><h3>${escapeHtml(pack.name)}</h3><p>${escapeHtml(ui.full)} · ${pack.artworks.length} ${escapeHtml(ui.artworks)}</p><p>${escapeHtml(ui.qty)}: ${line.quantity} · ${money(pack.price * line.quantity)}</p></div><button type="button" data-preview-remove="${pack.id}">${escapeHtml(ui.remove)}</button></article>`;
    }).join('') : `<p>${escapeHtml(ui.empty)}</p>`;
    root.querySelector('[data-preview-cart-total]').textContent = basket.length ? `${ui.total}: ${money(basket.reduce((sum,line) => sum + packs.find(pack => pack.id === line.id).price * line.quantity,0))}` : '';
    try { sessionStorage.setItem(cartKey, JSON.stringify(basket)); } catch {}
  };
  if (packs.length) {
    renderBasket();
    root.querySelectorAll('[data-preview-add]').forEach(button => button.addEventListener('click', () => {
      const line = basket.find(item => item.id === button.dataset.previewAdd);
      if (line) line.quantity = Math.min(99,line.quantity + 1); else basket.push({id:button.dataset.previewAdd,quantity:1});
      renderBasket();
      basketDialog.showModal();
    }));
    basketDialog.addEventListener('click', event => {
      const remove = event.target.closest('[data-preview-remove]');
      if (remove) { basket = basket.filter(line => line.id !== remove.dataset.previewRemove); renderBasket(); }
    });
  }
  root.querySelectorAll('[data-preview-cart-close]').forEach(button => button.addEventListener('click', () => basketDialog.close()));
  const tiles = [...root.querySelectorAll('[data-collection-tile]')];
  const panels = [...root.querySelectorAll('[data-collection-panel]')];
  const search = root.querySelector('[data-collection-search]');
  const season = root.querySelector('[data-collection-season]');
  let subject = 'all';
  const closeCollections = () => {
    panels.forEach(panel => { panel.hidden = true; });
    root.querySelectorAll('[data-open-collection]').forEach(button => button.setAttribute('aria-expanded', 'false'));
  };
  const scrollToCollection = element => {
    const header = document.querySelector('.shopify-section-header-sticky');
    element.style.scrollMarginTop = `${(header ? header.getBoundingClientRect().height : 0) + 18}px`;
    element.scrollIntoView({behavior:'smooth', block:'start'});
  };
  const filterCollections = () => {
    const query = search.value.trim().toLowerCase();
    closeCollections();
    tiles.forEach(tile => { tile.hidden = (subject !== 'all' && tile.dataset.artSubject !== subject) || (season.value !== 'all' && tile.dataset.season !== season.value) || !tile.dataset.search.includes(query); });
    const count = tiles.filter(tile => !tile.hidden).length;
    root.querySelector('[data-art-count]').textContent = String(count);
    root.querySelector('[data-catalogue-empty]').hidden = count > 0;
  };
  root.querySelectorAll('[data-subject]').forEach(button => button.addEventListener('click', () => {
    subject = button.dataset.subject;
    root.querySelectorAll('[data-subject]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    filterCollections();
  }));
  if (search) {
    filterCollections();
    search.addEventListener('input', filterCollections);
    season.addEventListener('change', filterCollections);
    root.querySelectorAll('[data-open-collection]').forEach(button => button.addEventListener('click', () => {
      closeCollections();
      const panel = panels.find(item => item.dataset.collectionPanel === button.dataset.openCollection);
      panel.hidden = false;
      root.querySelectorAll('[data-open-collection]').forEach(item => item.setAttribute('aria-expanded', String(item.dataset.openCollection === button.dataset.openCollection)));
      scrollToCollection(panel);
    }));
    root.querySelectorAll('[data-back-collections]').forEach(button => button.addEventListener('click', () => {
      const selected = button.closest('[data-collection-panel]').dataset.collectionPanel;
      closeCollections();
      const opener = root.querySelector(`[data-open-collection="${selected}"]`);
      opener.focus({preventScroll:true});
      scrollToCollection(root.querySelector('#cc-winter-heading'));
    }));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
